import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import SettingsCollection, {
	ArchiveRestoreMutationTuple,
} from '../../../generic/SettingsCollection';

export default function CareersSettings() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useCareersQuery}
			lazyQuery={graphql.useCareersLazyQuery}
			field="careers"
			translationKey="settings.growthPath.careers"
			title={(career) => localize(career.title).text}
			link={(career) => `/settings/jobs/growth-path/${career.id}`}
			variables={{}}
			archive={graphql.useArchiveCareerMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreCareerMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/jobs/growth-path/new')}
		/>
	);
}
